import(/* webpackMode: "eager" */ "/onedev-build/work/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/onedev-build/work/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/onedev-build/work/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/onedev-build/work/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Anybody\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":\"variable\",\"variable\":\"--font-anybody\",\"axes\":[\"wdth\"]}],\"variableName\":\"anybody\"}");
;
import(/* webpackMode: "eager" */ "/onedev-build/work/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Archivo\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":\"variable\",\"variable\":\"--font-archivo\",\"axes\":[\"wdth\"]}],\"variableName\":\"archivo\"}");
;
import(/* webpackMode: "eager" */ "/onedev-build/work/node_modules/lenis/dist/lenis.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/inits/GsapInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/inits/HotjarInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/inits/LazyInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/inits/LenisInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/onedev-build/work/src/app/components/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/onedev-build/work/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/onedev-build/work/src/app/cookies.css");
